import script from "./purchaseListCont.vue?vue&type=script&setup=true&name=puchaseListCont&lang=js"
export * from "./purchaseListCont.vue?vue&type=script&setup=true&name=puchaseListCont&lang=js"

const __exports__ = script;

export default __exports__